<template>
  <div class="vipCardDiscountConfirm">
    <el-dialog
      title="请选择折扣方式"
      :visible.sync="visible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :show-close="false"
      :before-close="close">
      <div class="content">
        <div class="tips">优惠券和整单议价不可与【至尊卡折扣】叠加使用！</div>
        <div class="info">
          <div class="info_row">
            <div class="info_label">至尊卡折扣：</div>
            <div class="info_value">{{ discountRate / 10 }}折</div>
          </div>
          <div class="info_row">
            <div class="info_label">原单折后价：</div>
            <div class="info_value">￥{{ discountMap.remaining }}</div>
            <div class="info_description">优惠￥{{ discountMap.discount }}</div>
          </div>
        </div>
        <div class="footer">
          <el-button @click="confirm(1)">不使用</el-button>
          <el-button type="primary" @click="confirm(2)">使用至尊卡折扣</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'VipCardDiscountConfirm',
    data () {
      return {
        visible: false,
        originalPrice: 0,
        discountRate: 100
      }
    },
    computed: {
      discountMap () {
        const remaining = Math.round(this.originalPrice * (this.discountRate / 100) * 100) / 100
        const discount = Math.round((this.originalPrice - remaining) * 100) / 100
        return {
          remaining: remaining,
          discount: discount
        }
      }
    },
    methods: {
      open(info) {
        this.originalPrice = ['', null, undefined].includes(info.originalPrice) ? 0 : info.originalPrice
        this.discountRate = ['', null, undefined].includes(info.discountRate) ? 100 : info.discountRate
        this.visible = true
      },
      close() {
        this.visible = false
      },
      confirm (type) {
        this.$emit('confirm', type)
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  .vipCardDiscountConfirm {
    overflow: hidden;
  }

  .vipCardDiscountConfirm /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .vipCardDiscountConfirm /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }
  
  .vipCardDiscountConfirm /deep/ .el-dialog__body {
    padding: 0;
  }

  .vipCardDiscountConfirm /deep/ .el-dialog__footer {
    padding: 12px 20px;
  }

  .content {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
  }

  .tips {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    font-size: 14px;
    color: #FE8F1F;
    background-color: #FFFBE8;
  }

  .info {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
  }

  .info_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .info_label {
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .info_value {
    line-height: 20px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .info_description {
    margin: 0 0 0 8px;
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .footer {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 8px 0 16px 0;
    padding: 0 16px;
    width: 100%;
  }
</style>
